import { render } from "./RentsTable.vue?vue&type=template&id=9e54c740"
import script from "./RentsTable.vue?vue&type=script&lang=js"
export * from "./RentsTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"RentsTable.vue"]])

export default __exports__